import {
    ALL_CONTRACT_EMPLOYEES_FETCHING,
    ALL_CONTRACT_EMPLOYEES_FAILED,
    ALL_CONTRACT_EMPLOYEES_SUCCESS,
  } from "../actions/types";
  
  const initialState = {
    result: null,
    isFetching: false,
    isError: false,
  };
  
  export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case ALL_CONTRACT_EMPLOYEES_FETCHING:
        return { ...state, result: null, isFetching: true, isError: false };
      case ALL_CONTRACT_EMPLOYEES_FAILED:
        return { ...state, result: null, isFetching: false, isError: true };
      case ALL_CONTRACT_EMPLOYEES_SUCCESS:
        return { ...state, result: payload, isFetching: false, isError: false };
      default:
        return state;
    }
  }
  